import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function LoginHintModal({ onClose }) {
  const navigate = useNavigate();

  const handleConfirm = () => {
    onClose();
    navigate('/login');
  };

  // ✅ ESC schließen (wichtig für UX)
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3>Bitte einloggen</h3>

        <p>
          Um diese Seite nutzen zu können, musst du eingeloggt sein.
        </p>

        <div className="modal-buttons">
          <button className="green-button" onClick={handleConfirm}>
            Zum Login
          </button>

          <button className="cancel-btn" onClick={onClose}>
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginHintModal;